export var Position;
(function (Position) {
    Position["RIGHT"] = "RIGHT";
    Position["LEFT"] = "LEFT";
})(Position || (Position = {}));
export var ReservedBloodProductsStatus;
(function (ReservedBloodProductsStatus) {
    ReservedBloodProductsStatus["STARTED"] = "I";
    ReservedBloodProductsStatus["RESTARTED"] = "R";
    ReservedBloodProductsStatus["PENDING"] = "N";
    ReservedBloodProductsStatus["INTERRUPTED"] = "INT";
    ReservedBloodProductsStatus["TERMINATE"] = "T";
    ReservedBloodProductsStatus["SUSPEND"] = "S";
})(ReservedBloodProductsStatus || (ReservedBloodProductsStatus = {}));
//# sourceMappingURL=blood-management-details-card-types.js.map